import { Avatar, Group, Menu, Stack, Text, UnstyledButton, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconChevronDown, IconKey, IconLogout, IconMoon, IconSun, IconUserCircle } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import { ROLE_LABELS } from '@mexp/shared';
import { useCurrentUser, useAuth } from '@/auth/AuthProvider';
import { initials } from '@/lib/format';

export function UserMenu() {
  const user = useCurrentUser();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { setColorScheme } = useMantineColorScheme();
  const scheme = useComputedColorScheme('light');

  return (
    <Menu position="bottom-end" width={240} shadow="md" withinPortal>
      <Menu.Target>
        <UnstyledButton aria-label="Account menu">
          <Group gap={8} wrap="nowrap">
            <Avatar radius="xl" size={34} color="brand">
              {initials(user.fullName)}
            </Avatar>
            <Stack gap={0} visibleFrom="sm">
              <Text fz="sm" fw={600} lh={1.2} maw={160} truncate>
                {user.fullName}
              </Text>
              <Text fz="xs" c="dimmed" lh={1.2}>
                {ROLE_LABELS[user.role]}
              </Text>
            </Stack>
            <IconChevronDown size={14} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{user.email}</Menu.Label>
        <Menu.Item leftSection={<IconUserCircle size={16} />} onClick={() => navigate('/internal/profile')}>
          My account
        </Menu.Item>
        <Menu.Item leftSection={<IconKey size={16} />} onClick={() => navigate('/internal/profile#password')}>
          Change password
        </Menu.Item>
        <Menu.Item
          leftSection={scheme === 'dark' ? <IconSun size={16} /> : <IconMoon size={16} />}
          onClick={() => setColorScheme(scheme === 'dark' ? 'light' : 'dark')}
        >
          {scheme === 'dark' ? 'Light mode' : 'Dark mode'}
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          color="red"
          leftSection={<IconLogout size={16} />}
          onClick={async () => {
            await logout();
            navigate('/internal/login', { replace: true });
          }}
        >
          Sign out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
